import { CellContext } from '@tanstack/react-table';
import { Skeleton, tableHelpers } from '@round/creatorbase-ui';
import { ResultCreator } from '../../../ResultCreator/ResultCreator';
import { getMeta, OutreachResultRow } from '../../../../helpers';
import styles from './CreatorCell.module.css';

type Props = CellContext<tableHelpers.WithLoadingRow<OutreachResultRow>, unknown>;

export const CreatorCell = ({ row: { original }, table }: Props) => {
    const { isLoading, getAvatarUrl, areAvatarsLoading, onOpenCreatorDetails } = getMeta(table);

    if (tableHelpers.isLoadingRow(original) || isLoading) {
        return (
            <div className={styles.loadingContainer}>
                <Skeleton className={styles.avatarSkeleton} />
                <Skeleton className={styles.usernameSkeleton} />
            </div>
        );
    }

    return (
        <ResultCreator
            username={original.username}
            avatarUrl={getAvatarUrl(original.user_id)}
            isAvatarLoading={areAvatarsLoading}
            clientInfluencerAccountId={original.client_influencer_account_id}
            onOpenDetails={onOpenCreatorDetails}
        />
    );
};
